export const NAME_MAX_LENGTH = 40;
export const ABOUT_MAX_LENGTH = 1000;
export const DESIGNER_ABOUT_MAX_LENGTH = 700;
export const CONTACTS_MAX_LENGTH = 100;
export const PHONE_MAX_LENGTH = 20;
export const PHONE_PATTERN = new RegExp(/^[0-9/+\s]+$/);export const NAME_MAX_LENGTH = 40;
export const ABOUT_MAX_LENGTH = 1000;
export const DESIGNER_ABOUT_MAX_LENGTH = 700;
export const CONTACTS_MAX_LENGTH = 100;
export const PHONE_MAX_LENGTH = 20;
export const PHONE_PATTERN = new RegExp(/^[0-9/+\s]+$/);